// ── Product page: keep the Men's/Women's "Fit" cross-link out of ────────
// ── variant matching. The active Fit pill is a <span> with no          ──
// ── data-value, so counting it shifted Size/Color by one position and  ──
// ── every lookup missed, forcing in-stock products to render Sold Out. ──
// Runs at top level of this deferred script, i.e. as soon as the document
// has parsed, so the corrected state lands before DOMContentLoaded work.
(function () {
  var fitGroups = document.querySelectorAll('.variant-options--fit');
  if (!fitGroups.length) return;
  fitGroups.forEach(function (g) { g.classList.remove('variant-options'); });
  // The page already ran its match once, while Fit was still counted.
  // Re-trigger it through the theme's own handler now that Fit is excluded.
  var group = document.querySelector('.variant-options');
  var active = group && group.querySelector('.variant-option.active');
  if (!active) return;
  var wasSoldOut = active.classList.contains('sold-out');
  if (wasSoldOut) active.classList.remove('sold-out');
  active.click();
  if (wasSoldOut) active.classList.add('sold-out');
})();

document.addEventListener('DOMContentLoaded', function () {

  // ── Hero slideshow ─────────────────────────────────────
  (function () {
    var slides = document.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var current = 0;
    function nextSlide() {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }
    setInterval(nextSlide, 5000);
  })();

  // ── Search toggle ──────────────────────────────────────
  (function () {
    var bar = document.getElementById('search-bar');
    var inp = document.getElementById('search-input');
    if (!bar) return;
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = bar.classList.toggle('is-open');
        bar.setAttribute('aria-hidden', !open);
        if (open && inp) setTimeout(function () { inp.focus(); }, 280);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { bar.classList.remove('is-open'); bar.setAttribute('aria-hidden', 'true'); }
    });
  })();

  // ── Mobile nav ─────────────────────────────────────────
  (function () {
    var nav = document.querySelector('.mobile-nav');
    var hamburger = document.querySelector('.hamburger');
    var closeBtn = document.querySelector('.mobile-nav__close');
    var overlay = document.querySelector('.mobile-nav__overlay');
    if (!nav) return;
    function openNav() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeNav() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (hamburger) hamburger.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
    document.querySelectorAll('.mobile-nav__accordion-toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var body = toggle.nextElementSibling;
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (body) body.classList.toggle('is-open', !isOpen);
      });
    });
  })();


  // ── Carousel ───────────────────────────────────────────
  (function () {
    var track = document.getElementById('car-track');
    var prevBtn = document.getElementById('car-prev');
    var nextBtn = document.getElementById('car-next');
    var dotsEl = document.getElementById('car-dots');
    if (!track) return;
    var slides = track.querySelectorAll('.carousel-slide');
    var current = 0;
    function getPerView() {
      if (window.innerWidth <= 640) return 2;
      if (window.innerWidth <= 1024) return 3;
      return 4;
    }
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      var pv = getPerView();
      var total = Math.ceil(slides.length / pv);
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.idx = i;
        dot.addEventListener('click', function () { goTo(parseInt(this.dataset.idx)); });
        dotsEl.appendChild(dot);
      }
    }
    function goTo(idx) {
      var pv = getPerView();
      var max = Math.max(0, slides.length - pv);
      current = Math.max(0, Math.min(idx, max));
      var gap = 2;
      var slideW = slides[0].offsetWidth + gap;
      track.style.transform = 'translateX(-' + (current * slideW) + 'px)';
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= max;
      if (dotsEl) dotsEl.querySelectorAll('.carousel-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === Math.floor(current / pv));
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); }
    });
    window.addEventListener('resize', function () { buildDots(); goTo(0); });
    buildDots();
    goTo(0);
  })();

  // ── Collection filter toggle ───────────────────────────
  var filterBtn = document.getElementById('filter-btn');
  var filterPanel = document.getElementById('filter-panel');
  if (filterBtn && filterPanel) {
    filterBtn.addEventListener('click', function () {
      filterPanel.style.display = filterPanel.style.display === 'none' ? 'block' : 'none';
    });
  }

  // ── Collection view toggle ─────────────────────────────
  document.querySelectorAll('.view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.view-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var grid = document.getElementById('product-grid');
      if (grid) grid.className = 'collection-grid ' + (btn.dataset.view || '');
    });
  });

  // ── Group colorways of the same style together ─────────
  (function () {
    function familyKey(card) {
      if (card.dataset && card.dataset.family) return 'f:' + card.dataset.family;
      var t = card.querySelector('.pcard__title');
      if (!t) return '';
      return 't:' + t.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    }
    function groupGrid(grid) {
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.pcard'));
      if (cards.length < 2) return;
      var order = [];
      var buckets = Object.create(null);
      var loose = 0;
      cards.forEach(function (card) {
        var k = familyKey(card);
        if (!k || k === 't:') { k = 'u:' + (loose++); }
        if (!buckets[k]) { buckets[k] = []; order.push(k); }
        buckets[k].push(card);
      });
      if (order.length === cards.length) return;
      order.forEach(function (k) {
        buckets[k].forEach(function (card) { grid.appendChild(card); });
      });
    }
    function groupAll() {
      document.querySelectorAll('.collection-grid').forEach(function (g) { groupGrid(g); });
    }
    groupAll();
    if (typeof window.filterCategory === 'function') {
      var origFilterCategory = window.filterCategory;
      window.filterCategory = function (btn, cat) {
        origFilterCategory(btn, cat);
        groupAll();
      };
    }
  })();

  // ── Scroll reveal ──────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); revealObs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealObs.observe(el); });
  }

  // ── Product page tabs ──────────────────────────────────
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = btn.dataset.tab;
      var container = btn.closest('.product-tabs');
      if (!container) return;
      container.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      container.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = container.querySelector('.tab-panel[data-tab="' + tab + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  // ── Product gallery thumbnails ─────────────────────────
  (function () {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImg = document.querySelector('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImg.src = thumb.querySelector('img').src;
      });
    });
  })();

  // ── Add to cart (Shopify AJAX) ─────────────────────────
  var addToCartBtn = document.querySelector('.add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      var variantId = document.querySelector('[name="id"]') ? document.querySelector('[name="id"]').value : null;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function (data) {
        showCartToast(data.title);
        updateCartCount();
      }).catch(function (err) { console.error(err); });
    });
  }

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var badge = document.querySelector('.cart-count');
      if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    });
  }
  updateCartCount();

  function showCartToast(title) {
    var existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML = '<div class="cart-toast__inner"><div class="cart-toast__check">✓</div><div><strong>' + title + '</strong><span>Added to cart</span></div><a href="/cart" class="cart-toast__view">View Cart</a></div>';
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3500);
  }

  // ── Variant selector ───────────────────────────────────
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.variant-options');
      if (group) group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var hiddenInput = document.querySelector('[name="id"]');
      if (hiddenInput && btn.dataset.variantId) hiddenInput.value = btn.dataset.variantId;
    });
  });

});
